'use client';

import toast from 'react-hot-toast';

import { AlertToast } from './alert-toast';
import type { Notify } from './notify.types';

export const notify: Notify = {
  alert: {
    success: (content, options) =>
      toast.custom(
        (t) => (
          <AlertToast rhtToastProps={t} variant="success" content={content} />
        ),
        options
      ),
    error: (content, options) =>
      toast.custom(
        (t) => (
          <AlertToast rhtToastProps={t} variant="error" content={content} />
        ),
        options
      ),
  },
  dismiss: (toastId) => toast.dismiss(toastId),
  remove: (toastId) => toast.remove(toastId),
};
